import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
@Injectable()
export class HttpInterceptorImpl implements HttpInterceptor {

  constructor(private spinnerService: NgxSpinnerService) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiUrl = req.url.substring(req.url.lastIndexOf('/'));
    if (apiUrl == '/saveBasicInfo' || apiUrl == '/getBasicInfo'
    || apiUrl == '/getAdditionalInfo'|| apiUrl == '/saveAdditionalInfo'
    || apiUrl == '/getChoiceInfo'|| apiUrl == '/saveChoiceInfo'
    || apiUrl=='/scholarship'|| apiUrl=='/saveFeedback') {
      this.spinnerService.show();

      return next.handle(req).pipe(
        finalize(
          () => {
            this.spinnerService.hide();
          }
        )
      );
    }
    else{
      return next.handle(req);
    }
  }
}